module.exports = "https://cdn.thelire.com/ins/resource/lite_hybird_android_face.fd38f83ffcd0ce0a9d89a12c6765a589.jpg";